// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__ClassifierModel from "../../models/ClassifierModel.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import ReactInfiniteScrollComponent from "react-infinite-scroll-component";
import * as JsxRuntime from "react/jsx-runtime";

function make(ogds) {
  return function (onKogdSelect) {
    return function (setIsDropdownShown) {
      const match = React.useState(function () {
            return /* [] */0;
          });
      const setDisplayData = match[1];
      const displayData = match[0];
      const match$1 = React.useState(function () {
            return true;
          });
      const setHasMore = match$1[1];
      const page = React.useRef(1);
      React.useEffect((function () {
              if (20 >= Buhta_cabinet__ClassifierModel.ogdLength(ogds)) {
                Curry._1(setDisplayData, (function (param) {
                        return ogds;
                      }));
              } else {
                Curry._1(setDisplayData, (function (param) {
                        return Buhta_cabinet__ClassifierModel.takeOgds(ogds, 20);
                      }));
              }
              page.current = 1;
              Curry._1(setHasMore, (function (param) {
                      return true;
                    }));
            }), [ogds]);
      const loadMore = function (param) {
        if (Buhta_cabinet__ClassifierModel.ogdLength(displayData) >= Buhta_cabinet__ClassifierModel.ogdLength(ogds)) {
          Curry._1(setHasMore, (function (param) {
                  return false;
                }));
        }
        page.current = page.current + 1 | 0;
        if (Math.imul(20, page.current) >= Buhta_cabinet__ClassifierModel.ogdLength(ogds)) {
          return Curry._1(setDisplayData, (function (param) {
                        return ogds;
                      }));
        } else {
          return Curry._1(setDisplayData, (function (param) {
                        return Buhta_cabinet__ClassifierModel.takeOgds(ogds, Math.imul(20, page.current));
                      }));
        }
      };
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(ReactInfiniteScrollComponent, {
                        children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, param) {
                                    const ogds = param[1];
                                    const term = param[0];
                                    const Key = "region_" + String(i);
                                    return JsxRuntime.jsxs("div", {
                                                children: [
                                                  term === "" || Stdlib__List.length(ogds) === 0 ? null : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                          className: "px-4 py-1 col-span-4 text-gray-medium",
                                                          children: Buhta_cabinet__ClassifierModel.mapTerm(term)
                                                        }),
                                                  Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, ogd) {
                                                              if (ogd.code.substring(2, 4) === "01") {
                                                                return null;
                                                              }
                                                              const Key = "k-" + String(i);
                                                              return JsxRuntime.jsxs("div", {
                                                                          children: [
                                                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                  className: "min-w-[36px]",
                                                                                  children: ogd.code
                                                                                }),
                                                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                  children: ogd.name
                                                                                })
                                                                          ],
                                                                          className: "flex items-center gap-4 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
                                                                          onClick: (function (param) {
                                                                              Curry._1(onKogdSelect, ogd.code);
                                                                              Curry._1(setIsDropdownShown, (function (param) {
                                                                                      return false;
                                                                                    }));
                                                                            })
                                                                        }, Key);
                                                            }), ogds))
                                                ],
                                                className: "contents"
                                              }, Key);
                                  }), displayData)),
                        next: loadMore,
                        hasMore: match$1[0],
                        dataLength: Buhta_cabinet__ClassifierModel.ogdLength(displayData),
                        className: "contents",
                        scrollableTarget: "ogdScrollWrapper"
                      }),
                  className: "flex flex-col mt-4 overflow-y-auto content-start",
                  id: "ogdScrollWrapper"
                });
    };
  };
}

function KogdTableView(Props) {
  return Curry._1(make(Props.ogds)(Props.onKogdSelect), Props.setIsDropdownShown);
}

const rows = 20;

const make$1 = KogdTableView;

export {
  rows ,
  make$1 as make,
}
/* Buhta_components__Text Not a pure module */
